import { render, staticRenderFns } from "./Board.vue?vue&type=template&id=3151b237&scoped=true&"
import script from "./Board.vue?vue&type=script&lang=js&"
export * from "./Board.vue?vue&type=script&lang=js&"
import style0 from "./Board.vue?vue&type=style&index=0&id=3151b237&prod&lang=less&scoped=true&"
import style1 from "./Board.vue?vue&type=style&index=1&id=3151b237&prod&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3151b237",
  null
  
)

export default component.exports